import { Action, createReducer, on } from '@ngrx/store';
import { fromEmployeeWithdrawalsActions } from '../actions';

export const employeeWithdrawalFeatureKey = 'updateWithdrawal';

export interface EmployeeWithdrawalState {
  loadEmployeeWithdrawalResponse: { success: boolean };
  loadEmployeeWithdrawalFailure: Error | any;
}

export const initialState: EmployeeWithdrawalState = {
  loadEmployeeWithdrawalResponse: undefined,
  loadEmployeeWithdrawalFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromEmployeeWithdrawalsActions.updateWithdrawalResponse, (state, action) => ({
    ...state,
    loadEmployeeWithdrawalResponse: action.response
  })),
  on(fromEmployeeWithdrawalsActions.updateWithdrawalFailure, (state, action) => ({
    ...state,
    loadEmployeeWithdrawalFailure: action.error
  }))
);
